/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetEmployeeAttendance200ResponseItemsInner } from './GetEmployeeAttendance200ResponseItemsInner';
import {
    GetEmployeeAttendance200ResponseItemsInnerFromJSON,
    GetEmployeeAttendance200ResponseItemsInnerFromJSONTyped,
    GetEmployeeAttendance200ResponseItemsInnerToJSON,
    GetEmployeeAttendance200ResponseItemsInnerToJSONTyped,
} from './GetEmployeeAttendance200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetEmployeeAttendance200Response
 */
export interface GetEmployeeAttendance200Response {
    /**
     * 
     * @type {Array<GetEmployeeAttendance200ResponseItemsInner>}
     * @memberof GetEmployeeAttendance200Response
     */
    items: Array<GetEmployeeAttendance200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeAttendance200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeAttendance200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeAttendance200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetEmployeeAttendance200Response interface.
 */
export function instanceOfGetEmployeeAttendance200Response(value: object): value is GetEmployeeAttendance200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetEmployeeAttendance200ResponseFromJSON(json: any): GetEmployeeAttendance200Response {
    return GetEmployeeAttendance200ResponseFromJSONTyped(json, false);
}

export function GetEmployeeAttendance200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmployeeAttendance200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetEmployeeAttendance200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetEmployeeAttendance200ResponseToJSON(json: any): GetEmployeeAttendance200Response {
    return GetEmployeeAttendance200ResponseToJSONTyped(json, false);
}

export function GetEmployeeAttendance200ResponseToJSONTyped(value?: GetEmployeeAttendance200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetEmployeeAttendance200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

